// https://github.com/mui-org/material-ui-x/blob/master/packages/grid/x-data-grid-generator/src/renderer/renderProgress.tsx

import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import round from '../../util/round';

const Root = styled('div')(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  position: 'relative',
  overflow: 'hidden',
  width: '100%',
  height: 26,
  borderRadius: 2,
}));

const Value = styled('div')({
  position: 'absolute',
  lineHeight: '24px',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
});

const Bar = styled('div')(({ level }) => ({
  height: '100%',
  backgroundColor:
    level === 'low' ? '#088208a3' :
    level === 'medium' ? '#efbb5aa3' : '#f44336',
}));

const ProgressBar = React.memo(function ProgressBar(props) {
  const {
    value: { total, used },
  } = props;

  const valueInPercent = round(total === 0 ? 100 : (used / total) * 100, 0);
  
  const level = valueInPercent <= 50 ? 'low' :
    valueInPercent > 50 && valueInPercent <= 75 ? 'medium' : 'high';

  return (
    <Root>
      <Value>
        {`${valueInPercent.toLocaleString()} %`} of {total}
      </Value>
      <Bar level={level} style={{ maxWidth: `${valueInPercent}%` }} />
    </Root>
  );
});

export default function renderProgress(params) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <ProgressBar value={params.value} />
    </Box>
  );
}
